import React from 'react';
import Proptypes from 'prop-types';
import _ from 'lodash';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { VIEW_DATASET_SUMMARY } from '../../constants/saxs';
import SaxsFrameListContainer from './helpers/SaxsFrameListContainer';
import FrameListTable from '../../components/saxs/FrameListTable';
import SaxsFrameListPlotterContainer from './helpers/SaxsFrameListPlotterContainer';
import FramePlotter from '../../components/saxs/FramePlotter';
import DataCollectionListPanel from '../../components/saxs/DataCollection/DataCollectionListPanel';
import SaxsDataCollectionsContainer from './helpers/SaxsDataCollectionsContainer';

class SaxsDataCollectionReductionContainer extends React.Component {
    render() {
        let _this = this;
        return (<div style={{ paddingBottom: '70px' }}>
            <SaxsDataCollectionsContainer experimentId={this.props.experimentId} proposal={this.props.proposal} token={this.props.user.token} >
                {dataCollections => {
                    let filteredDataCollections = _.filter(dataCollections, dataCollection => { return dataCollection.dataCollectionId == _this.props.dataCollectionId }) || []
                    return <div>
                        <DataCollectionListPanel
                            dataCollections={filteredDataCollections}
                            experimentId={this.props.experimentId}
                            proposal={this.props.proposal}
                            sessionId={this.props.sessionId}
                            token={this.props.user.token}
                            view={VIEW_DATASET_SUMMARY} />
                            
                        <SaxsFrameListContainer
                            dataCollectionId={this.props.dataCollectionId}
                            proposal={this.props.proposal}
                            dataCollectionSubtractions={filteredDataCollections}
                            token={this.props.user.token} >
                            {(frames, selectedFrames, onRowClicked, scale, onScaleChanged) => {
                                return (<Grid fluid>
                                    <Row >
                                        <Col xs={4} style={{ height: '500px', overflowY: 'scroll' }} >
                                            <FrameListTable frames={frames} selectedFrames={selectedFrames} onRowClicked={onRowClicked} scale={scale} onScaleChanged={onScaleChanged} />
                                        </Col>
                                        <Col xs={8}>
                                            <SaxsFrameListPlotterContainer
                                                frames={selectedFrames}
                                                scale={scale}
                                                token={this.props.user.token}>
                                                {framesWithCSV => {
                                                    return <div>
                                                        <FramePlotter data={framesWithCSV} />
                                                    </div>
                                                }}
                                            </SaxsFrameListPlotterContainer>
                                        </Col>
                                    </Row>
                                </Grid>)
                            }
                            }
                        </SaxsFrameListContainer>
                    </div>
                }}
            </SaxsDataCollectionsContainer>

        </div>)
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps, () => null)(SaxsDataCollectionReductionContainer);

SaxsDataCollectionReductionContainer.proptypes = {
    /** experiment identifier */
    experimentId: Proptypes.number,
    /** data collection identifier */
    dataCollectionId: Proptypes.number,
    /** proposal name */
    proposal: Proptypes.string,
    /** session identifier */
    sessionId: Proptypes.string
}


// WEBPACK FOOTER //
// ./src/containers/saxs/SaxsDataCollectionReductionContainer.js